<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Administrators
          <div class="card-header-actions">
            <a href="#" @click="addAdminForm">
              <i class="fa fa-user-plus"></i>
            </a>
          </div>        
      </b-card-header>
      <b-card-body>
        <Admins/>
      </b-card-body>
    </b-card>

    <b-modal title="Register Admin" class="modal-warning" v-model="warningModal" @ok="addAdmin" ok-variant="warning">
      <b-form-group
          label="Auth ID"
          :label-cols="3">
        <b-form-input type="text" v-model="uid" placeholder="Enter ID"></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
  import { ClientTable, Event } from 'vue-tables-2'
  import Admins from '../users/Admins'

  export default {
    name: 'AdminList',
    components: {
      ClientTable,
      Event,
      Admins
    },
    data: function() {
      return {
        uid: null,
        warningModal: false,
      }
    },
    methods: {
      addAdminForm() {
        this.warningModal = true
      },
      async addAdmin() {
        if (!this.uid) return
        console.info('add Admin')
        await this.$http.post('/api/mkAdmin', {uid: this.uid})
      }
    }
  };
</script>
